<div class="content-card">
  <h2 class="content-card__header">{{ 'AEF-Wage' | translate }}</h2>
  <form [formGroup]="wageFormGroup">
    @if (wages.errors?.MinLengthArray) {
      <alert message="WageIsRequiredErrorMessage" alertType="error"></alert>
    }
    <div class="wages-wrapper">
      @for (wage of wages.controls; track wage; let i = $index) {
        <div class="row" formArrayName="wages">
          <div class="col-3" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'Wage' | translate }}</mat-label>
              <input matInput type="number" class="text-center" formControlName="value" min="0" required />
              @if (wages.controls[i].get('value').invalid && wages.controls[i].get('value').touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-2" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'Currency' | translate }}</mat-label>
              <mat-select formControlName="currencyId">
                @for (currency of listOfCurrencies$ | async; track currency) {
                  <mat-option [value]="currency.Id">
                    {{ currency.Name }}
                  </mat-option>
                }
              </mat-select>
              @if (wages.controls[i].get('currencyId').invalid && wages.controls[i].get('currencyId').touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-3" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'WageType' | translate }}</mat-label>
              <mat-select formControlName="wageTypeId">
                @for (wageType of listOfWageTypes$ | async | filterWageType : wages.value : i; track wageType) {
                  <mat-option [value]="wageType.Id">
                    {{ wageType.Name }}
                  </mat-option>
                }
              </mat-select>
              @if (wages.controls[i].get('wageTypeId').invalid && wages.controls[i].get('wageTypeId').touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          @if (hasManyWages()) {
            <div class="col-1">
              <button mat-icon-button color="primary" class="trash-button" (click)="deleteWage(i)" [disabled]="wageCounter <= miminumWages">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </form>
</div>
